export default __webpack_public_path__ + "static/media/tqicon-4.9e84acba.svg";